import dayjs from "@/lib/dayjs";

import { useCalender } from "../../../context/calendar/calendar-context";
import { isDayPickerRange } from "../../../types/calendar-range";
import { isDayPickerSingle } from "../../../types/calendar-single";

import type { MouseEventHandler } from "react";

export function useDayEventHandlers() {
	const calendar = useCalender();

	const onClick: MouseEventHandler<HTMLButtonElement> = (e) => {
		if (isDayPickerSingle(calendar)) {
			calendar.onSelect(e.currentTarget.value);
		}

		if (isDayPickerRange(calendar)) {
			const { from, to } = calendar.selected;
			const value = e.currentTarget.value;

			if ((from && to) || (!from && !to)) {
				calendar.onSelect({ from: value, to: "" });
			}

			if (from && !to) {
				const fromDayjs = dayjs(from);
				const toDayjs = dayjs(value);

				if (fromDayjs.isBefore(toDayjs)) {
					calendar.onSelect({ from, to: value });
				}

				if (fromDayjs.isAfter(toDayjs)) {
					calendar.onSelect({ from: value, to: "" });
				}

				if (fromDayjs.isSame(toDayjs)) {
					calendar.onSelect({ from, to: value });
				}
			}
		}
	};

	return { onClick };
}
